<div class="page-wrapper">
    <!-- <app-sentry-example /> -->
    <div class="page-head">
        <h1>{{ "assignments.title" | translate }}</h1>
        <!-- <div *ngIf="customer && customer.employeeRole?.id != 3" class="flex-shrink-0">
            <button type="button"
                class="w-full sm:w-auto bg-gradient-to-r from-blue-600 via-blue-600/95 to-blue-500 hover:from-blue-700 hover:via-blue-700/95 hover:to-blue-600 text-white flex items-center justify-center font-medium transition-all duration-300 hover:scale-[1.02] hover:shadow-lg group relative overflow-hidden ring-2 ring-blue-400/30 hover:ring-blue-400/50 px-[24px] py-[12px] rounded-lg text-base shadow-xl"
                (click)="onCreateAssignment()">
                <div
                    class="absolute inset-0 bg-gradient-to-r from-white/10 via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-plus w-5 h-5 mr-2 relative z-10 transition-transform duration-300 group-hover:scale-110">
                    <path d="M5 12h14"></path>
                    <path d="M12 5v14"></path>
                </svg>
                <span class="relative z-10">
                    {{ 'assignments.create' | translate }}
                </span>
                <div
                    class="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                </div>
            </button>
        </div> -->
    </div>
    <div class="assignment-calender">
        <div
            class="assignment-prev-btn flex items-center bg-card border border-border rounded-xl overflow-hidden w-full sm:w-auto shadow-sm focus:outline-none outline-none"
        >
            <button
                type="button"
                (click)="goPrev()"
                aria-label="Previous Month"
                class="prev-btn flex items-center justify-center hover:bg-blue-50 hover:text-blue-600 text-muted-foreground transition-all duration-300 hover:scale-110 px-[12px] py-[12px] focus:outline-none outline-none"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-chevron-left"
                >
                    <path d="m15 18-6-6 6-6"></path>
                </svg>
            </button>
            <span
                class="px-[16px] py-[12px] font-medium text-foreground flex-1 text-center sm:flex-none whitespace-nowrap text-base cursor-context-menu focus:outline-none outline-none"
                >{{ currentTitle }}</span
            >
            <button
                type="button"
                (click)="goNext()"
                aria-label="Next Month"
                class="next-btn flex items-center justify-center hover:bg-blue-50 hover:text-blue-600 text-muted-foreground transition-all duration-300 hover:scale-110 px-[12px] py-[12px] focus:outline-none outline-none"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-chevron-right"
                >
                    <path d="m9 18 6-6-6-6"></path>
                </svg>
            </button>
        </div>

        <!-- assignment-month-list-section -->
        <div
            class="assignment-month-section flex items-center bg-card border border-border rounded-xl overflow-hidden w-full sm:w-auto shadow-sm"
        >
            <button
                type="button"
                (click)="changeView('dayGridMonth')"
                [disabled]="innerWidth <= 768"
                aria-label="Day Grid Month"
                class="flex items-center justify-center transition-all duration-300 flex-1 sm:flex-none !text-muted-foreground hover:bg-blue-50 hover:text-blue-600 month-view-btn px-[12px] py-[12px]"
                [class.active]="durationchange"
                [class.disabled]="innerWidth <= 768"
            >
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5.33398 1.33301V3.99967"
                        stroke="currentColor"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M10.666 1.33301V3.99967"
                        stroke="currentColor"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M12.6667 2.66699H3.33333C2.59695 2.66699 2 3.26395 2 4.00033V13.3337C2 14.07 2.59695 14.667 3.33333 14.667H12.6667C13.403 14.667 14 14.07 14 13.3337V4.00033C14 3.26395 13.403 2.66699 12.6667 2.66699Z"
                        stroke="currentColor"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M2 6.66699H14"
                        stroke="currentColor"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
            <button
                type="button"
                (click)="changeView('timeGridWeek')"
                aria-label="Time Grid Week"
                class="flex items-center justify-center transition-all duration-300 flex-1 sm:flex-none !text-muted-foreground hover:bg-blue-50 hover:text-blue-600 month-view-btn px-[12px] py-[12px]"
                [class.active]="!durationchange"
            >
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5.33398 4H14.0007"
                        stroke="currentColor"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M5.33398 8H14.0007"
                        stroke="currentColor"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M5.33398 12H14.0007"
                        stroke="currentColor"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M2 4H2.00667"
                        stroke="currentColor"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M2 8H2.00667"
                        stroke="currentColor"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M2 12H2.00667"
                        stroke="currentColor"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
        </div>

        <div class="filter-btn" *ngIf="customer">
            <button
                type="button"
                #filterMenuTrigger="matMenuTrigger"
                [matMenuTriggerFor]="menu"
                aria-label="Filter"
                class="w-full sm:w-auto border-blue-200/50 bg-blue-50/70 hover:bg-blue-100 text-blue-700 hover:text-blue-800 hover:border-blue-300 flex items-center justify-center font-medium transition-all duration-300 hover:scale-[1.01] hover:shadow-lg group px-[24px] py-[12px] text-[16px] border border-blue-200 !rounded-[8px]"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="lucide lucide-filter w-[16px] h-[16px] mr-[8px] transition-transform duration-300 group-hover:scale-110"
                >
                    <polygon
                        points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                    ></polygon>
                </svg>
                <span>{{ "assignments.filters.filter" | translate }}</span>
            </button>
        </div>

        <mat-menu
            #menu="matMenu"
            yPosition="below"
            [hasBackdrop]="true"
            class="tooltip-menu filter-menu"
        >
            <div class="filter-modal" (click)="$event.stopPropagation()">
                <div class="filter-header">
                    <h4>
                        <i>
                            <svg
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M16.5 2.25H1.5L7.5 9.345V14.25L10.5 15.75V9.345L16.5 2.25Z"
                                    stroke="#4B5563"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </i>
                        <span>{{
                            "assignments.filters.filter" | translate
                        }}</span>
                    </h4>
                    <button
                        type="button"
                        class="close-btn"
                        (click)="closeFilterMenu()"
                        aria-label="Close"
                    >
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M15 5L5 15"
                                stroke="currentColor"
                                stroke-width="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M5 5L15 15"
                                stroke="currentColor"
                                stroke-width="1.66667"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                </div>

                <div class="filter-body grid gap-6">
                    <div class="filter-box grid gap-2">
                        <label class="filter-label">{{
                            "assignments.filters.filter-by-job-status-text"
                                | translate
                        }}</label>
                        <div class="select-container" [class.open]="isJobOpen">
                            <div
                                class="select-display"
                                (click)="toggleJobDropdown()"
                            >
                                <div class="select-text">
                                    {{
                                        selectedStatus?.label ||
                                            ("assignments.filters.select-status"
                                                | translate)
                                    }}
                                </div>
                                <div class="select-arrow">
                                    <svg
                                        class="arrow-icon"
                                        [class.rotate]="isJobOpen"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M19 9l-7 7-7-7"
                                        ></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="select-dropdown" *ngIf="isJobOpen">
                                <div class="search-container">
                                    <div class="search-icon">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        >
                                            <circle
                                                cx="11"
                                                cy="11"
                                                r="8"
                                            ></circle>
                                            <line
                                                x1="21"
                                                y1="21"
                                                x2="16.65"
                                                y2="16.65"
                                            ></line>
                                        </svg>
                                    </div>
                                    <input
                                        type="text"
                                        class="search-input"
                                        [placeholder]="
                                            'assignments.filters.search'
                                                | translate
                                        "
                                        (click)="$event.stopPropagation()"
                                        [(ngModel)]="statusSearchText"
                                    />
                                    <div
                                        class="clear-icon"
                                        [class.hidden]="false"
                                        (click)="statusSearchText = ''"
                                    >
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        >
                                            <line
                                                x1="18"
                                                y1="6"
                                                x2="6"
                                                y2="18"
                                            ></line>
                                            <line
                                                x1="6"
                                                y1="6"
                                                x2="18"
                                                y2="18"
                                            ></line>
                                        </svg>
                                    </div>
                                </div>
                                <div class="options-list">
                                    <div
                                        *ngIf="filteredStatusItems.length === 0"
                                        class="no-results"
                                    >
                                        No results found
                                    </div>
                                    <div
                                        *ngFor="
                                            let option of filteredStatusItems
                                        "
                                        class="option-item"
                                        [class.selected]="
                                            option.value ===
                                            selectedStatus?.value
                                        "
                                        (click)="onStatusSelect(option)"
                                    >
                                        <div>
                                            {{ option.label }}
                                        </div>
                                        <div
                                            *ngIf="
                                                option.value ===
                                                selectedStatus?.value
                                            "
                                            class="check-icon"
                                        >
                                            <svg
                                                width="18"
                                                height="18"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            >
                                                <polyline
                                                    points="20 6 9 17 4 12"
                                                ></polyline>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="filter-box grid gap-2">
                        <label class="filter-label">{{
                            "assignments.filters.filter-by-job-place-text"
                                | translate
                        }}</label>
                        <div class="select-container" [class.open]="isOpen">
                            <div
                                class="select-display"
                                (click)="togglePlaceDropdown()"
                            >
                                <div class="select-text">
                                    {{
                                        selectedItem?.label ||
                                            ("assignments.filters.select-job-place"
                                                | translate)
                                    }}
                                </div>
                                <div class="select-arrow">
                                    <svg
                                        class="arrow-icon"
                                        [class.rotate]="isOpen"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            d="M19 9l-7 7-7-7"
                                        ></path>
                                    </svg>
                                </div>
                            </div>
                            <div class="select-dropdown" *ngIf="isOpen">
                                <div class="search-container">
                                    <div class="search-icon">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        >
                                            <circle
                                                cx="11"
                                                cy="11"
                                                r="8"
                                            ></circle>
                                            <line
                                                x1="21"
                                                y1="21"
                                                x2="16.65"
                                                y2="16.65"
                                            ></line>
                                        </svg>
                                    </div>
                                    <input
                                        type="text"
                                        class="search-input"
                                        [placeholder]="
                                            'assignments.filters.search'
                                                | translate
                                        "
                                        (click)="$event.stopPropagation()"
                                        [(ngModel)]="placeSearchText"
                                    />
                                    <div
                                        class="clear-icon"
                                        [class.hidden]="false"
                                        (click)="placeSearchText = ''"
                                    >
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        >
                                            <line
                                                x1="18"
                                                y1="6"
                                                x2="6"
                                                y2="18"
                                            ></line>
                                            <line
                                                x1="6"
                                                y1="6"
                                                x2="18"
                                                y2="18"
                                            ></line>
                                        </svg>
                                    </div>
                                </div>
                                <div class="options-list">
                                    <div
                                        *ngIf="filteredPlaceItems.length === 0"
                                        class="no-results"
                                    >
                                        No results found
                                    </div>
                                    <div
                                        *ngFor="
                                            let option of filteredPlaceItems
                                        "
                                        class="option-item"
                                        [class.selected]="
                                            option.value === selectedItem?.value
                                        "
                                        (click)="onPlaceSelect(option)"
                                    >
                                        <div>
                                            {{ option.label }}
                                        </div>
                                        <div
                                            *ngIf="
                                                option.value ===
                                                selectedItem?.value
                                            "
                                            class="check-icon"
                                        >
                                            <svg
                                                width="18"
                                                height="18"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            >
                                                <polyline
                                                    points="20 6 9 17 4 12"
                                                ></polyline>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        class="filter-box grid"
                        *ngIf="
                            selectedItem?.label &&
                            customer?.employeeRole?.id != 3
                        "
                    >
                        <div class="default-toggle">
                            <span class="tag" *ngIf="selectedItem?.label">{{
                                selectedItem?.label
                            }}</span>
                            <div class="switch-container">
                                <span class="label-text">Standard</span>
                                <label class="switch">
                                    <input
                                        type="checkbox"
                                        [checked]="
                                            selectedItem?.is_default === 1 ||
                                            selectedItem?.value.isDefault ===
                                                true
                                        "
                                        (change)="onDefaultToggle($event)"
                                    />
                                    <span class="slider"></span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="filter-box grid gap-2 filter-box-popup">
                        <label class="filter-label">{{
                            "assignments.filters.date-range" | translate
                        }}</label>
                        <div class="daterange-wrapper">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-calendar-icon lucide-calendar absolute left-3 top-1/2 -translate-y-1/2 text-[#727272]"
                            >
                                <path d="M8 2v4" />
                                <path d="M16 2v4" />
                                <rect
                                    width="18"
                                    height="18"
                                    x="3"
                                    y="4"
                                    rx="2"
                                />
                                <path d="M3 10h18" />
                            </svg>

                            <input
                                type="text"
                                name="daterange"
                                ngxDaterangepickerMd
                                [(ngModel)]="selected"
                                [locale]="localeData"
                                [ranges]="ranges"
                                class="form-control"
                                [alwaysShowCalendars]="true"
                                [linkedCalendars]="false"
                                [showCancel]="true"
                                [closeOnAutoApply]="false"
                            />

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="lucide lucide-chevron-down-icon lucide-chevron-down text-[#727272] absolute right-3 top-1/2 -translate-y-1/2"
                            >
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </div>
                    </div>
                    <div class="filter-box grid gap-2">
                        <label class="filter-label">{{
                            "assignments.filters.filter-by-skills" | translate
                        }}</label>
                        <div class="skills-tags">
                            <span
                                *ngFor="let skill of skills"
                                class="tag"
                                [class.selected]="
                                    selectedSkills.includes(skill)
                                "
                                (click)="toggleSkill(skill)"
                            >
                                {{ skill | skillDisplayName }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="filter-footer">
                    <button
                        type="button"
                        class="reset-btn"
                        (click)="resetFilters()"
                    >
                        {{ "assignments.filters.reset" | translate }}
                    </button>
                    <button
                        type="button"
                        class="apply-btn"
                        (click)="applyFilters()"
                    >
                        {{ "assignments.filters.apply" | translate }}
                    </button>
                </div>
            </div>
        </mat-menu>
    </div>
    <div class="w-full overflow-x-auto">
        <div
            class="bg-blue-50 border-y border-blue-100 p-3 sticky top-[12px] mb-4 z-10"
            *ngIf="
                customer &&
                showFilterChip &&
                currentView === 'dayGridMonth' &&
                (selectedItem ||
                    selectedStatus ||
                    (selectedSkills && selectedSkills.length > 0))
            "
        >
            <div class="flex items-center justify-between">
                <div class="flex items-center">
                    <span class="text-gray-700 font-medium mr-3"
                        >{{ "assignments.filters.filter" | translate }}:</span
                    >
                    <div class="flex flex-wrap gap-2">
                        <div
                            *ngIf="selectedItem"
                            class="bg-white border border-blue-200 rounded-md px-2 py-1 flex items-center text-sm"
                        >
                            <span class="text-blue-800 mr-1"
                                >{{
                                    "assignments.filters.place" | translate
                                }}:</span
                            >
                            <span class="text-gray-800">{{
                                selectedItem.label
                            }}</span>
                            <button
                                type="button"
                                class="ml-2 text-gray-500 hover:text-gray-700"
                                (click)="removeFilter('place')"
                                aria-label="Remove Filter"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-x"
                                >
                                    <path d="M18 6 6 18"></path>
                                    <path d="m6 6 12 12"></path>
                                </svg>
                            </button>
                        </div>
                        <div
                            *ngIf="selectedStatus"
                            class="bg-white border border-blue-200 rounded-md px-2 py-1 flex items-center text-sm"
                        >
                            <span class="text-blue-800 mr-1">Status:</span>
                            <span class="text-gray-800">{{
                                selectedStatus.label
                            }}</span>
                            <button
                                type="button"
                                class="ml-2 text-gray-500 hover:text-gray-700"
                                (click)="removeFilter('status')"
                                aria-label="Remove Filter"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-x"
                                >
                                    <path d="M18 6 6 18"></path>
                                    <path d="m6 6 12 12"></path>
                                </svg>
                            </button>
                        </div>
                        <div
                            *ngFor="let skill of selectedSkills; let i = index"
                            class="bg-white border border-blue-200 rounded-md px-2 py-1 flex items-center text-sm"
                        >
                            <span class="text-blue-800 mr-1"
                                >{{
                                    "assignments.filters.skill" | translate
                                }}:</span
                            >
                            <span class="text-gray-800">{{
                                skill | skillDisplayName
                            }}</span>
                            <button
                                type="button"
                                class="ml-2 text-gray-500 hover:text-gray-700"
                                (click)="removeSkill(i)"
                                aria-label="Remove Filter"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-x"
                                >
                                    <path d="M18 6 6 18"></path>
                                    <path d="m6 6 12 12"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <button
                    type="button"
                    class="text-blue-600 hover:text-blue-800 text-sm font-medium"
                    (click)="resetFiltersChip()"
                    aria-label="Clear All"
                >
                    {{ "assignments.filters.clear-all" | translate }}
                </button>
            </div>
        </div>
        <!-- Unauthenticated hint: blank calendar, log in to see data -->
        <div
            *ngIf="!customer && currentView === 'dayGridMonth'"
            class="text-center py-6 text-muted-foreground text-sm"
        >
            {{ "assignments.login-to-view" | translate }}
        </div>
        <full-calendar
            #fullCalendar
            [options]="calendarOptions"
            class="full-calendar"
            *ngIf="currentView === 'dayGridMonth'"
        >
        </full-calendar>
    </div>

    <div class="list-view" *ngIf="currentView === 'timeGridWeek'">
        <div
            class="bg-gradient-to-r from-white to-gray-50/50 !border-t !border-gray-200/80 !border-b !border-gray-200/80 backdrop-blur-sm container mx-auto !px-[24px] !max-w-full"
        >
            <div
                class="flex sm:items-center sm:justify-between py-[16px] flex-col gap-4 sm:gap-6 sm:flex-row"
            >
                <div class="space-y-[4px]">
                    <div class="text-gray-800 font-semibold text-[20px]">
                        {{ getassignmentsTotalCount() }}
                        {{
                            getassignmentsTotalCount() <= 1
                                ? ("assignments.list-view.assignment"
                                  | translate)
                                : ("assignments.list-view.assignments"
                                  | translate)
                        }}
                    </div>
                    <div class="text-[14px] text-gray-500">
                        {{ "assignments.list-view.title" | translate }}
                    </div>
                </div>

                <div class="flex items-center gap-[8px]">
                    <button
                        type="button"
                        (click)="filterListViewByStatusOrDate('date')"
                        [class]="
                            'inline-flex items-center text-[14px] px-[16px] py-[10px] !rounded-[12px] font-medium transition-all duration-200 ' +
                            (sortField === 'date'
                                ? 'bg-blue-600 text-white shadow-[0_10px_15px_-3px_rgba(59,130,246,0.25)] hover:bg-blue-700 hover:shadow-[0_10px_15px_-3px_rgba(59,130,246,0.3)]'
                                : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50 hover:border-gray-300 shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]')
                        "
                        aria-label="Date"
                    >
                        {{ "assignments.table-heading.date" | translate }}
                        <!-- Ascending Arrow -->
                        <svg
                            *ngIf="
                                sortField === 'date' && sortDirection === 'asc'
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="ml-[4px]"
                        >
                            <path d="m5 12 7-7 7 7"></path>
                            <path d="M12 19V5"></path>
                        </svg>
                        <!-- Descending Arrow -->
                        <svg
                            *ngIf="
                                sortField === 'date' && sortDirection === 'desc'
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="ml-[4px]"
                        >
                            <path d="m19 12-7 7-7-7"></path>
                            <path d="M12 5v14"></path>
                        </svg>
                        <!-- Default Arrow (when not sorting by date) -->
                        <svg
                            *ngIf="sortField !== 'date'"
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="ml-[4px] opacity-60"
                        >
                            <path d="m5 12 7-7 7 7"></path>
                            <path d="M12 19V5"></path>
                        </svg>
                    </button>

                    <button
                        type="button"
                        (click)="filterListViewByStatusOrDate('status')"
                        [class]="
                            'inline-flex items-center text-[14px] px-[16px] py-[10px] !rounded-[12px] font-medium transition-all duration-200 ' +
                            (sortField === 'status'
                                ? 'bg-blue-600 text-white shadow-[0_10px_15px_-3px_rgba(59,130,246,0.25)] hover:bg-blue-700 hover:shadow-[0_10px_15px_-3px_rgba(59,130,246,0.3)]'
                                : 'bg-white text-gray-600 border border-gray-200 hover:bg-gray-50 hover:border-gray-300 shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]')
                        "
                        aria-label="Status"
                    >
                        {{ "assignments.table-heading.status" | translate }}
                        <!-- Ascending Arrow -->
                        <svg
                            *ngIf="
                                sortField === 'status' &&
                                sortDirection === 'asc'
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="ml-[4px]"
                        >
                            <path d="m5 12 7-7 7 7"></path>
                            <path d="M12 19V5"></path>
                        </svg>
                        <!-- Descending Arrow -->
                        <svg
                            *ngIf="
                                sortField === 'status' &&
                                sortDirection === 'desc'
                            "
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="ml-[4px]"
                        >
                            <path d="m19 12-7 7-7-7"></path>
                            <path d="M12 5v14"></path>
                        </svg>
                        <!-- Default Arrow (when not sorting by status) -->
                        <svg
                            *ngIf="sortField !== 'status'"
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="ml-[4px] opacity-60"
                        >
                            <path d="m21 16-4 4-4-4"></path>
                            <path d="M17 20V4"></path>
                            <path d="m3 8 4-4 4 4"></path>
                            <path d="M7 4v16"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
        <div class="px-[16px] md:px-[24xp] py-[24px] hidden md:block">
            <div
                class="w-[100%] overflow-x-auto rounded-[12px] shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] border-[1px] border-[rgba(229,231,235,0.6)] overflow-hidden"
            >
                <table class="min-w-[700px] border-collapse w-full bg-white">
                    <!-- Row 1 -->
                    <ng-container *ngFor="let assignment of assignments">
                        <ng-container
                            *ngFor="
                                let event of assignment?.events;
                                let i = index
                            "
                        >
                            <tr
                                (click)="openStatusModal(event)"
                                class="group/row hover:bg-gradient-to-r hover:from-blue-50/50 hover:to-indigo-50/30 transition-all duration-200 cursor-pointer"
                            >
                                <td
                                    *ngIf="i === 0"
                                    [attr.rowspan]="assignment.events.length"
                                    class="px-[16px] py-[12px] !border-b-[1px] !border-[rgba(243,244,246,0.6)]"
                                >
                                    <div class="flex items-center">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-calendar text-blue-400 mr-[12px]"
                                        >
                                            <path d="M8 2v4"></path>
                                            <path d="M16 2v4"></path>
                                            <rect
                                                width="18"
                                                height="18"
                                                x="3"
                                                y="4"
                                                rx="2"
                                            ></rect>
                                            <path d="M3 10h18"></path>
                                        </svg>
                                        <span
                                            class="font-medium text-gray-700 text-sm"
                                        >
                                            {{
                                                assignment.date
                                                    | date
                                                        : "MMM d, y"
                                                        : ""
                                                        : currentLang
                                            }}
                                        </span>
                                    </div>
                                </td>
                                <td
                                    class="px-[16px] py-[12px] !border-b-[1px] !border-[rgba(243,244,246,0.6)]"
                                >
                                    <div class="flex items-center">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            class="lucide lucide-clock text-emerald-400 mr-[12px]"
                                        >
                                            <circle
                                                cx="12"
                                                cy="12"
                                                r="10"
                                            ></circle>
                                            <polyline
                                                points="12 6 12 12 16 14"
                                            ></polyline>
                                        </svg>
                                        <span
                                            class="font-medium text-gray-700 text-sm"
                                            >{{ event?.startTime }} -
                                            {{ event?.endTime }}</span
                                        >
                                    </div>
                                </td>
                                <td
                                    class="px-[16px] py-[12px] !border-b-[1px] !border-[rgba(243,244,246,0.6)]"
                                >
                                    <div
                                        class="font-semibold text-base group-hover/row:text-blue-700"
                                    >
                                        {{ event?.jobPlace?.jobPlaceName }}
                                    </div>
                                    <div
                                        class="text-gray-500 mt-[4px] truncate border-none text-sm"
                                    >
                                        {{ event?.skill?.name }}
                                    </div>
                                </td>
                                <td
                                    [matTooltip]="
                                        getStatusTooltip(
                                            event.status,
                                            event.reliabilityPercentage
                                        )
                                    "
                                    matTooltipPosition="above"
                                    class="status-div px-[16px] py-[12px] !border-b-[1px] !border-[rgba(243,244,246,0.6)]"
                                >
                                    <div
                                        class="status-div flex items-center bg-white rounded-md px-[8px] text-xs text-gray-700 font-medium"
                                        [ngClass]="
                                            statusMap[event.status]?.class
                                        "
                                    >
                                        <div
                                            class="flex items-center justify-center p-[4px] rounded-full mr-[6px]"
                                        >
                                            <i
                                                [innerHTML]="
                                                    statusMap[event.status]
                                                        ?.icon
                                                "
                                            >
                                            </i>
                                        </div>
                                        <span>{{
                                            statusMap[event?.status]?.label
                                        }}</span>
                                    </div>
                                </td>
                                <td
                                    class="px-[16px] py-[12px] !border-b-[1px] !border-[rgba(243,244,246,0.6)]"
                                >
                                    <div class="flex -space-x-[8px]">
                                        <ng-container
                                            *ngFor="
                                                let worker of event.hired
                                                    | slice: 0 : 2
                                            "
                                        >
                                            <ng-container
                                                *ngIf="
                                                    worker.image;
                                                    else fallbackImage
                                                "
                                            >
                                                <img
                                                    [src]="worker.image"
                                                    loading="lazy"
                                                    [alt]="
                                                        worker.aliasName
                                                            ? worker.aliasName
                                                            : worker.firstName
                                                              ? worker.firstName
                                                              : ''
                                                    "
                                                    class="w-[40px] h-[40px] rounded-full border-[2px] border-white object-cover shadow-sm"
                                                    [matTooltip]="
                                                        worker.aliasName
                                                            ? worker.aliasName
                                                            : worker.firstName
                                                              ? worker.firstName
                                                              : ''
                                                    "
                                                    matTooltipPosition="above"
                                                />
                                            </ng-container>
                                            <ng-template #fallbackImage>
                                                <div
                                                    class="w-[40px] h-[40px] rounded-full border-[2px] border-white bg-gray-300 flex items-center justify-center text-sm font-medium text-gray-600 shadow-sm"
                                                    [matTooltip]="
                                                        worker.aliasName
                                                            ? worker.aliasName
                                                            : worker.firstName
                                                              ? worker.firstName
                                                              : ''
                                                    "
                                                    matTooltipPosition="above"
                                                >
                                                    {{
                                                        worker.aliasName?.charAt(
                                                            0
                                                        )
                                                            ? worker.aliasName?.charAt(
                                                                  0
                                                              )
                                                            : worker.firstName?.charAt(
                                                                    0
                                                                )
                                                              ? worker.firstName?.charAt(
                                                                    0
                                                                )
                                                              : "-"
                                                    }}
                                                </div>
                                            </ng-template>
                                        </ng-container>
                                        <div
                                            class="flex items-center ml-[10px]"
                                            *ngIf="
                                                event.hired &&
                                                event.hired.length > 3
                                            "
                                        >
                                            <div
                                                class="w-[32px] h-[32px] rounded-[9999px] bg-[rgb(219,234,254)] border-[1px] border-[rgb(191,219,254)] flex items-center justify-center text-[12px] text-[rgb(37,99,235)] font-[500] shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]"
                                            >
                                                +{{ event.hired.length - 2 }}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td
                                    class="px-[16px] py-[12px] !border-b-[1px] !border-[rgba(243,244,246,0.6)]"
                                >
                                    <button
                                        type="button"
                                        class="bg-blue-600 text-white font-medium hover:bg-blue-700 hover:shadow-lg hover:shadow-blue-600/25 group-hover/row:scale-105 transition-all duration-200 px-[16px] py-[8px] !rounded-[8px] text-sm"
                                    >
                                        {{
                                            "assignments.list-view.show-details"
                                                | translate
                                        }}
                                    </button>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </table>
            </div>
        </div>
        <!-- mobile view -->
        <div class="overflow-y-auto px-4" id="mobile-scroll-container">
            <ng-container *ngFor="let assignment of assignments">
                <ng-container
                    *ngFor="let event of assignment?.events; let i = index"
                >
                    <div
                        class="px-[16px] py-[24px] block md:hidden mobile-container space-y-4"
                    >
                        <div
                            (click)="openStatusModal(event)"
                            class="mobile-card-interactive bg-white rounded-[12px] shadow-[0_1px_2px_0_rgba(0,0,0,0.05)] border-[1px] border-[rgba(229,231,235,0.6)] transition-all duration-[300ms] group p-[16px]"
                        >
                            <div class="flex justify-between mb-[12px]">
                                <div class="flex-1 min-w-0 pr-[12px]">
                                    <h3
                                        class="text-[16px] font-semibold text-[#111827] mb-[4px] truncate"
                                    >
                                        {{ event?.jobPlace?.jobPlaceName }}
                                    </h3>
                                    <div
                                        class="text-[14px] text-[#4B5563] truncate"
                                    >
                                        {{ event?.skill?.name }}
                                    </div>
                                </div>

                                <!-- Status Badge -->
                                <div class="relative group">
                                    <div
                                        class="flex items-center bg-white rounded-[6px] px-[8px] py-[2px] text-[12px] text-[#374151] font-medium status-div"
                                        [ngClass]="
                                            statusMap[event.status]?.class
                                        "
                                    >
                                        <div
                                            class="flex items-center justify-center p-[4px] rounded-full mr-[6px]"
                                        >
                                            <i
                                                [innerHTML]="
                                                    statusMap[event.status]
                                                        ?.icon
                                                "
                                            ></i>
                                        </div>
                                        <span>{{
                                            statusMap[event?.status]?.label
                                        }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Date / Time -->
                            <div
                                class="flex flex-wrap text-[14px] text-[#4B5563] mb-[12px] bg-gradient-to-r from-[#F9FAFB] to-[#EFF6FF4D] rounded-[12px] p-[12px] border border-[#F3F4F6]"
                            >
                                <div class="flex items-center mr-[12px]">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="text-[#3B82F6] flex-shrink-0"
                                    >
                                        <path d="M8 2v4"></path>
                                        <path d="M16 2v4"></path>
                                        <rect
                                            width="18"
                                            height="18"
                                            x="3"
                                            y="4"
                                            rx="2"
                                        ></rect>
                                        <path d="M3 10h18"></path>
                                    </svg>
                                    <span
                                        class="font-semibold text-[#374151] ml-[6px]"
                                        >{{
                                            assignment.date
                                                | date
                                                    : "MMM
                                            d,
                                            y"
                                                    : ""
                                                    : "en-US"
                                        }}</span
                                    >
                                </div>
                                <div class="flex items-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="text-[#10B981] flex-shrink-0"
                                    >
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <polyline
                                            points="12 6 12 12 16 14"
                                        ></polyline>
                                    </svg>
                                    <span
                                        class="font-semibold text-[#374151] ml-[6px]"
                                        >{{ event?.startTime }} -
                                        {{ event?.endTime }}</span
                                    >
                                </div>
                            </div>

                            <!-- Avatar + Button -->
                            <div class="flex justify-between">
                                <div class="flex -space-x-[8px]">
                                    <div class="flex flex-row">
                                        <div
                                            class="flex -space-x-[8px] items-end"
                                        >
                                            <!-- Dynamic worker avatars and names -->
                                            <ng-container
                                                *ngFor="
                                                    let worker of event.hired
                                                        | slice: 0 : 3;
                                                    let i = index
                                                "
                                            >
                                                <div
                                                    class="flex flex-col -space-x-[8px]"
                                                >
                                                    <!-- Worker avatar with image fallback -->
                                                    <ng-container
                                                        *ngIf="
                                                            worker?.image;
                                                            else fallbackAvatar
                                                        "
                                                    >
                                                        <img
                                                            [src]="
                                                                worker?.image
                                                            "
                                                            loading="lazy"
                                                            [alt]="
                                                                worker?.aliasName
                                                                    ? worker?.aliasName
                                                                    : worker?.firstName
                                                                      ? worker?.firstName
                                                                      : ''
                                                            "
                                                            class="w-[40px] h-[40px] rounded-full border-[2px] border-white object-cover shadow-sm"
                                                            [matTooltip]="
                                                                worker?.aliasName
                                                                    ? worker?.aliasName
                                                                    : worker?.firstName
                                                                      ? worker?.firstName
                                                                      : ''
                                                            "
                                                            matTooltipPosition="above"
                                                        />
                                                    </ng-container>
                                                    <ng-template
                                                        #fallbackAvatar
                                                    >
                                                        <div
                                                            class="w-[40px] h-[40px] rounded-full border-[2px] border-white bg-gray-300 flex items-center justify-center text-sm font-medium text-gray-600 shadow-sm"
                                                            [matTooltip]="
                                                                worker?.aliasName
                                                                    ? worker?.aliasName
                                                                    : worker?.firstName
                                                                      ? worker?.firstName
                                                                      : ''
                                                            "
                                                            matTooltipPosition="above"
                                                        >
                                                            {{
                                                                worker?.aliasName?.charAt(
                                                                    0
                                                                )
                                                                    ? worker?.aliasName?.charAt(
                                                                          0
                                                                      )
                                                                    : worker?.firstName?.charAt(
                                                                            0
                                                                        )
                                                                      ? worker?.firstName?.charAt(
                                                                            0
                                                                        )
                                                                      : "-"
                                                            }}
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </ng-container>
                                            <!-- More workers indicator -->
                                            <div
                                                class="flex flex-col items-center ml-[10px]"
                                                *ngIf="
                                                    event.hired &&
                                                    event.hired.length > 3
                                                "
                                            >
                                                <div
                                                    class="w-[32px] h-[32px] rounded-[9999px] bg-[rgb(219,234,254)] border-[1px] border-[rgb(191,219,254)] flex items-center justify-center text-[12px] text-[rgb(37,99,235)] font-[500] shadow-[0_1px_2px_0_rgba(0,0,0,0.05)]"
                                                >
                                                    +{{
                                                        event?.hired?.length - 3
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <div
                                        class="text-[12px] text-[#6B7280] mb-[4px]"
                                    >
                                        {{ event?.hired?.length }}
                                        {{
                                            "create-assignment.guards"
                                                | translate
                                        }}
                                    </div>
                                    <button
                                        type="button"
                                        class="bg-blue-600 text-white font-medium hover:bg-blue-700 hover:shadow-lg hover:shadow-blue-600/25 group-hover/row:scale-105 transition-all duration-200 px-[16px] py-[8px] !rounded-[8px] text-sm"
                                    >
                                        {{
                                            "assignments.list-view.show-details"
                                                | translate
                                        }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>